import * as qs from "qs";
import * as _ from "underscore";

import APIClient from "../APIClient";

const uuid = require("uuid");

/* helpers */

const enumerate = (prefix, arr) =>
  _.chain(arr)
    .map(key => [key, `${prefix}_${key}`]) // prefix to namespace actions when reducers combined
    .object()
    .value();

/* actions */

// TODO: jjw: uncomment types below when updated to handle failures

export const actionTypes: any = enumerate("UNDERWRITER_DASHBOARD", [
  "REMOTE_REQUEST",
  // "RECENT_APPS_LOAD_FAILURE",
  "APP_LOAD_SUCCESS",
  "APP_LOAD_FAILURE",
  "HURDLE_OVERRIDE_CREATE_REQUEST",
  "HURDLE_OVERRIDE_CREATE_SUCCESS",
  // "HURDLE_OVERRIDE_CREATE_FAILURE",
  "HURDLE_OVERRIDE_UPDATE_REQUEST",
  // "HURDLE_OVERRIDE_UPDATE_FAILURE",
  "HURDLE_OVERRIDE_DELETE_REQUEST",
  // "HURDLE_OVERRIDE_DELETE_FAILURE",
  "DISCLOSURES_ADD_REQUEST",
  // "DISCLOSURES_ADD_FAILURE",
  "WVOE_VIEWING_EMPLOYMENT_ID",
  "FINISH_LOADING",
  "SET_CURRENT_HURDLE_NAME",
  "CLEAR_CURRENT_HURDLE_NAME",
]);

/* action creators */

const remoteRequest = () => ({
  type: actionTypes.REMOTE_REQUEST,
});

const appLoadSuccess = app => ({
  app,
  type: actionTypes.APP_LOAD_SUCCESS,
});

const appLoadFailed = () => ({
  type: actionTypes.APP_LOAD_FAILURE,
});

const hurdleOverrideCreateRequest = (
  appId,
  hurdleName,
  hurdleOverrideTempId,
  hurdleOverrideStatus,
  hurdleOverrideValues,
) => ({
  appId,
  hurdleName,
  hurdleOverrideTempId,
  hurdleOverrideStatus,
  hurdleOverrideValues,
  type: actionTypes.HURDLE_OVERRIDE_CREATE_REQUEST,
});

const hurdleOverrideCreateSuccess = (appId, hurdleOverrideTempId, hurdleOverrideRealId) => ({
  appId,
  hurdleOverrideTempId,
  hurdleOverrideRealId,
  type: actionTypes.HURDLE_OVERRIDE_CREATE_SUCCESS,
});

const hurdleOverrideUpdateRequest = (
  appId,
  hurdleOverrideId,
  hurdleOverrideStatus,
  hurdleOverrideValues,
) => ({
  appId,
  hurdleOverrideId,
  hurdleOverrideStatus,
  hurdleOverrideValues,
  type: actionTypes.HURDLE_OVERRIDE_UPDATE_REQUEST,
});

const hurdleOverrideDeleteRequest = (appId, hurdleOverrideId) => ({
  appId,
  hurdleOverrideId,
  type: actionTypes.HURDLE_OVERRIDE_DELETE_REQUEST,
});

const changeCurrentlyViewingEmploymentIdRequest = employmentIndex => ({
  employmentIndex,
  type: actionTypes.WVOE_VIEWING_EMPLOYMENT_ID,
});

/* exported async funcs */

export const loadApp = (dispatch: Function, appId) => {
  dispatch(remoteRequest());

  APIClient.get(`/loan_applications/${appId}`).then((resp: any) => {
    dispatch(appLoadSuccess(resp.application));
  });
};

export const updateLoanApp = (dispatch: Function, loanApp: any) => {
  dispatch(remoteRequest());

  APIClient.put(`/loan_applications/${loanApp.id}`, loanApp)
    .then((resp: any) => {
      dispatch(appLoadSuccess(resp.application));
    })
    .catch(() => dispatch(appLoadFailed()));
};

export const createHurdleOverride = (dispatch: Function, data) => {
  const { appId, hurdleName, hurdleOverrideStatus, hurdleOverrideValues } = data;

  const tempId = uuid.v4();

  dispatch(
    hurdleOverrideCreateRequest(
      appId,
      hurdleName,
      tempId,
      hurdleOverrideStatus,
      hurdleOverrideValues,
    ),
  );

  APIClient.post("/hurdle_overrides", {
    application_id: appId,
    hurdle_name: hurdleName,
    status: hurdleOverrideStatus,
    values: hurdleOverrideValues,
  }).then((resp: any) => {
    dispatch(hurdleOverrideCreateSuccess(appId, tempId, resp.override.id));
    loadApp(dispatch, appId);
  });
};

export const updateHurdleOverride = (dispatch: Function, data) => {
  const { appId, hurdleOverrideId, hurdleOverrideStatus, hurdleOverrideValues } = data;

  dispatch(
    hurdleOverrideUpdateRequest(
      appId,
      hurdleOverrideId,
      hurdleOverrideStatus,
      hurdleOverrideValues,
    ),
  );

  APIClient.put(`/hurdle_overrides/${hurdleOverrideId}`, {
    id: hurdleOverrideId,
    status: hurdleOverrideStatus,
    values: hurdleOverrideValues,
    application_id: appId,
  }).then(() => {
    loadApp(dispatch, appId);
  });
};

export const deleteHurdleOverride = (dispatch: Function, data) => {
  const { appId, hurdleOverrideId } = data;

  dispatch(hurdleOverrideDeleteRequest(appId, hurdleOverrideId));
  APIClient.deleteRequest(`/hurdle_overrides/${hurdleOverrideId}`).then(() => {
    loadApp(dispatch, appId);
  });
};

export const finishLoading = () => dispatch => dispatch({ type: actionTypes.FINISH_LOADING });

export const createNewDisclosure = (dispatch: Function, appId, stage, sendEsign) => {
  const payload: any = { stage, sendEsign };

  dispatch(remoteRequest());
  return APIClient.get(`/uw/${appId}/generate_disclosure?${qs.stringify(payload)}`)
    .then(() => {
      loadApp(dispatch, appId);
    })
    .catch(err => {
      dispatch(finishLoading());
      alert(err && err.meta && err.meta.error_detail);
    });
};

export const updateViewingEmploymentID = (dispatch: Function, employmentIndex) => {
  dispatch(changeCurrentlyViewingEmploymentIdRequest(employmentIndex));
};

export const setCurrentHurdleName = (hurdleName: string) => ({
  type: actionTypes.SET_CURRENT_HURDLE_NAME,
  hurdleName,
});

export const clearCurrentHurdleName = () => ({
  type: actionTypes.CLEAR_CURRENT_HURDLE_NAME,
});
